export default __webpack_public_path__ + "drag-indicator.744e9fa8fdfefbbb7e808dede164c6fb.svg";